import {createApi} from '@reduxjs/toolkit/query/react'
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {ProvinciaRecord} from "@commons/mapping/ProvinciaRecord";
import {ComuneRecord} from "@commons/mapping/ComuneRecord";
import {config} from "@commons/config.instance";

// FPNet2021/tabella/comune/VI
// FPNet2021/tabella/provincia
export const comuniApi = createApi({
    reducerPath: 'comuniApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet') + '/tabella/comune'}),
    tagTypes: ['Comuni'],
    endpoints: (builder) => ({
        getComuni: builder.query<ComuneRecord[], { siglaProv: string }>({
            query: ({siglaProv}) => {
                return '/' + siglaProv;
            }
        }),
    }),
})
export const {
    useGetComuniQuery,
} = comuniApi;

export const provinceApi = createApi({
    reducerPath: 'provinceApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet') + '/tabella/provincia'}),
    tagTypes: ['Province'],
    endpoints: (builder) => ({
        getProvince: builder.query<ProvinciaRecord[], void>({
            query: () => {
                return '';
            }
        }),
    }),
})
export const {
    useGetProvinceQuery,
} = provinceApi;